module.exports = __webpack_public_path__ + "static/media/expImgWhite.b50841e6.svg";